var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMineMine(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "34px",
    viewBox: "0 0 34 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_mine_mine") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9996\\u9875",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u4E2A\\u4EBA\\u4E2D\\u5FC3-\\u6211\\u7684\\u8BFE\\u5802",
    transform: "translate(-714, -160)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_mine_mine",
    transform: "translate(714, 160)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706\\u5F62",
    fill: "#FFFFFF",
    cx: 17,
    cy: 17,
    r: 17
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4",
    transform: "translate(9.5, 9)",
    fill: "#333333",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15,15.2590621 C15,15.6682708 14.6632941,16 14.2479464,16 C13.8325987,16 13.4958928,15.6682708 13.4958928,15.2590621 L13.4958928,15.2504192 L13.47436,15.2504192 C13.0794632,12.3842401 10.6275354,10.226615 7.69239971,10.1624625 C7.62780126,10.1648197 7.56479784,10.1718912 7.49940187,10.1718912 C7.43400589,10.1718912 7.37140122,10.1648197 7.30720154,10.1624625 C4.37359038,10.2285201 1.92388219,12.3856796 1.52922881,15.2504192 L1.51088604,15.2504192 L1.51088604,15.2590621 C1.51088604,15.6682708 1.17418018,16 0.758832452,16 C0.343484725,16 0.00677886556,15.6682708 0.00677886556,15.2590621 L0,15.1914899 C0.000279008029,15.0996875 0.0186986816,15.0088169 0.054230803,14.9239508 C0.44237915,12.4031708 2.13890857,10.2652889 4.52827181,9.28598724 C3.09577928,8.3538891 2.23193177,6.7772317 2.22705161,5.08589888 C2.25837547,2.24672119 4.61961804,-0.0300233441 7.50139565,0.000299405436 C10.3828632,-0.0295862406 12.7436171,2.24703128 12.7749422,5.08589888 C12.7700163,6.77651451 11.9068496,8.3525798 10.475317,9.28480865 C12.8892024,10.2730877 14.5944522,12.4431525 14.9609219,14.9930945 C14.9812665,15.0573634 14.9921438,15.1241763 14.9932212,15.1914899 L15,15.2590621 Z M11.2672462,5.08747032 C11.2201582,3.07110738 9.5475533,1.46070249 7.50039876,1.46070249 C5.45324422,1.46070249 3.78063936,3.07110738 3.73355132,5.08747032 C3.78063936,7.10383326 5.45324422,8.71423814 7.50039876,8.71423814 C9.5475533,8.71423814 11.2201582,7.10383326 11.2672462,5.08747032 L11.2672462,5.08747032 Z",
    id: "\\u5F62\\u72B6"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMineMine);
export default __webpack_public_path__ + "static/media/icon_mine_mine.svg";
export { ForwardRef as ReactComponent };